import {
	Button as ButtondMui
} from '@mui/material';
import { ChildrenProps, appendClassName } from '@componentLibraryWrapper/common';
import './button.scss';

export interface ButtonProps extends ChildrenProps<HTMLButtonElement> {
	color?: 'inherit' | 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning',
	disabled?: boolean
	href?: string
	type?: 'submit' | 'reset' | 'button' | undefined,
	variant?: 'text' | 'outlined' | 'contained',
}

// To add new custom style
// export type ButtonProps = {
// 	color?: 'inherit' | 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning' | 'ochre'
// }

// declare module '@mui/material/Button' {
//   interface ButtonPropsColorOverrides {
//     ochre: true;
//   }
// }

// <ButtondMui 
// 	color='ochre'/>

const Button = ({
	className,
	color='primary',
	disabled=false,
	type='button',
	variant='text',
	...rest
}: ButtonProps) => {
	return (
		<ButtondMui
			{...rest}
			className={appendClassName('sm-button', className)}
			color={color}
			disabled={disabled}
			type={type}
			variant={variant}/>
	)
}

export default Button;